import type { ModalInfoProps } from '@/components/ModalInfo/ModalInfo';
import { ModalInfo } from '@/components';
import { Flex, Heading, Text } from '@blockanalitica/ui';
import { farmMapping } from '@/utils/farms';

interface FarmModalProps extends Partial<ModalInfoProps> {
  address: string;
}

export default function FarmModal({ address, ...rest }: FarmModalProps) {
  const farmType = farmMapping(address);

  const getModalContent = () => {
    switch (farmType) {
      case 'chronicle_farm':
        return (
          <Flex flexDirection="column" gap="s">
            <Flex flexDirection="column" gap="xs">
              <Heading size="3">Why are the Points Variable?</Heading>
              <Text size="2">
                Eligible users of the Sky Protocol may access Chronicle token
                rewards (i.e., &quot;Chronicle Points&quot;) through the
                protocol&rsquo;s Rewards feature. A user&rsquo;s accumulated
                points will appear on the interface as &quot;Accumulated
                Rewards.&quot; These rewards are reflected as points (i.e., CLE
                points). The number of points displayed is determined by the
                amount of USDS deposited and the amount of Chronicle points
                being emitted.
              </Text>
            </Flex>

            <Flex flexDirection="column" gap="xs">
              <Heading size="3">How are Points Determined?</Heading>
              <Text size="2">
                Chronicle Points may be calculated at a rate of 10 points per
                unit with 10 billion total supply, as a reference, with
                Chronicle Points being emitted at a rate of 3.75 billion per
                year.
              </Text>
            </Flex>
          </Flex>
        );

      case 'spk_farm':
        return (
          <Flex flexDirection="column" gap="s">
            <Flex flexDirection="column" gap="xs">
              <Heading size="3">Why is the APY Variable?</Heading>
              <Text size="2">
                APY fluctuates based on several factors:
                <br />
                - SPK price
                <br />
                - SPK issuance rate
                <br />- total USDS in the farm
              </Text>
            </Flex>

            <Flex flexDirection="column" gap="xs">
              <Heading size="3">How is APY Determined?</Heading>
              <Text size="2">
                SPK farming is offered by the Sky ecosystem. Through Sky&rsquo;s
                token farms, users can stake USDS to farm SPK. SPK is
                distributed by Sky through these farms on a regular basis.
              </Text>
            </Flex>
          </Flex>
        );

      case 'sky_farm':
        return (
          <Flex flexDirection="column" gap="s">
            <Flex flexDirection="column" gap="xs">
              <Heading size="3">Why is the APY Variable?</Heading>
              <Text size="2">
                APY fluctuates based on several factors:
                <br />
                - SKY price
                <br />
                - SKY Protocol Governance decisions
                <br />- total USDS in the farm
              </Text>
            </Flex>

            <Flex flexDirection="column" gap="xs">
              <Heading size="3">How is APY Determined?</Heading>
              <Text size="2">
                SKY farming is offered by the Sky ecosystem. Through Sky&rsquo;s
                token farms, users can stake USDS to farm SKY. SKY is
                distributed by Sky through these farms on a regular basis.
              </Text>
            </Flex>
          </Flex>
        );

      case 'grove_farm':
        return (
          <Flex flexDirection="column" gap="s">
            <Flex flexDirection="column" gap="xs">
              <Heading size="3">Why is the APY Variable?</Heading>
              <Text size="2">
                APY fluctuates based on several factors:
                <br />
                - GROVE price
                <br />
                - GROVE issuance rate
                <br />- total USDS in the farm
              </Text>
            </Flex>
            <Flex flexDirection="column" gap="xs">
              <Heading size="3">How is APY Determined?</Heading>
              <Text size="2">
                SKY farming is offered by the Sky ecosystem. Through Sky&rsquo;s
                token farms, users can stake USDS to farm GROVE. GROVE is
                distributed by Sky through these farms on a regular basis.
              </Text>
            </Flex>
          </Flex>
        );

      default:
        return (
          <Flex flexDirection="column" gap="xs">
            <Text size="2">
              Farm information not available for this address.
            </Text>
          </Flex>
        );
    }
  };

  const getModalTitle = () => {
    switch (farmType) {
      case 'chronicle_farm':
        return 'USDS - Chronicle Farm Information';
      case 'spk_farm':
        return 'USDS - SPK Farm Information';
      case 'sky_farm':
        return 'USDS - SKY Farm Information';
      case 'grove_farm':
        return 'USDS - GROVE Farm Information';
      default:
        return 'Farm Information';
    }
  };

  return (
    <ModalInfo title={getModalTitle()} {...rest}>
      {getModalContent()}
    </ModalInfo>
  );
}
